import React, { useCallback, useContext } from 'react';
import styled from 'styled-components';

import Button from 'kingpin/atoms/Button';
import Icon from 'kingpin/atoms/Icon';
import Typography from 'kingpin/atoms/Typography';

import AnalyticsContext from 'contexts/AnalyticsContext';
import { Z_INDEX } from '../../constants';
import Row from 'components/Common/Row';

const BannerWrapper = styled.div`
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: ${Z_INDEX.TOAST};
  background-color: var(--color-navy);
  color: var(--color-text-inverse);
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  gap: 16px;
`;

const DismissButton = styled.button`
  position: absolute;
  top: 2px;
  left: 2px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
`;

interface Props {
  onDismiss: () => void;
  onReload: () => void;
}

const AppUpdateBanner = ({ onDismiss, onReload }: Props) => {
  const { trackEvent } = useContext(AnalyticsContext);

  const handleReload = useCallback(() => {
    trackEvent('App - Soft Update Reloaded');
    onReload();
  }, [trackEvent, onReload]);

  const handleDismiss = useCallback(() => {
    trackEvent('App - Soft Update Dismissed');
    onDismiss();
  }, [trackEvent, onDismiss]);

  return (
    <BannerWrapper data-testid="app-update-banner">
      <DismissButton onClick={handleDismiss} aria-label="Dismiss">
        <Icon icon="cross" color="white" width={12} height={12} />
      </DismissButton>
      <Row centerAlign>
        <Typography.Body type="Body 12" color="white">
          A new version of FleetOps is available.
        </Typography.Body>
        <div style={{ marginLeft: 16 }}>
          <Button
            onClick={handleReload}
            label="Update now"
            type="Secondary"
            size="Small"
          />
        </div>
      </Row>
    </BannerWrapper>
  );
};

export default AppUpdateBanner;
